module.exports = __webpack_public_path__ + "assets/faba6ffa3283c6fa5b67a93cf63faddf.png";